/**
 * Convierte ítems del carrito al formato esperado por POST /api/v1/checkout.
 */
export function buildCheckoutCartLines(cartItems) {
  return cartItems.map((item) => {
    const line = {
      type: item.type,
      name: item.name,
      quantity: parseInt(item.quantity, 10) || 1,
      unit_price: parseFloat(item.price) || 0,
      cart_key: item.id,
    };

    if (item.type === 'combo') {
      line.combo_id = parseInt(item.comboId, 10);
      line.xetux_product_id = item.xetuxProductId ?? null;
      line.xetux_item_id = item.xetuxItemId ?? null;
      if (item.combinaciones?.length) {
        line.combinaciones = item.combinaciones;
      }
      if (item.rollsConSesamo !== undefined && item.rollsConSesamo !== null) {
        line.rollsConSesamo = item.rollsConSesamo;
      }
      if (item.rollsConQuesoCrema !== undefined && item.rollsConQuesoCrema !== null) {
        line.rollsConQuesoCrema = item.rollsConQuesoCrema;
      }
      if (item.rollsConCebollin !== undefined && item.rollsConCebollin !== null) {
        line.rollsConCebollin = item.rollsConCebollin;
      }
      if (
        item.rollsConQuesoCrema === undefined &&
        item.rollsConCebollin === undefined &&
        item.rollsConQuesoCremaCebollin !== undefined &&
        item.rollsConQuesoCremaCebollin !== null
      ) {
        line.rollsConQuesoCremaCebollin = item.rollsConQuesoCremaCebollin;
      }
      if (item.includedSauces?.length) {
        line.included_sauces = item.includedSauces;
      }
      if (item.includedDrink) {
        line.included_drink = item.includedDrink;
      }
    } else if (item.type === 'extra') {
      line.extra_id = parseInt(item.extraId, 10);
      line.xetux_product_id = item.xetuxProductId ?? null;
      line.xetux_item_id = item.xetuxItemId ?? null;
      if (item.accompaniments?.length) {
        line.accompaniments = item.accompaniments.map((piece) => ({
          product_name: piece.product_name,
          quantity: Number(piece.quantity) || 0,
          xetux_product_id: piece.xetux_product_id,
          xetux_item_id: piece.xetux_item_id,
          sku: piece.sku,
        }));
      }
      const parentMatch = String(item.id).match(/^extra-combo-(\d+)-/);
      if (parentMatch) {
        line.parent_combo_id = parseInt(parentMatch[1], 10);
      }
    } else if (item.type === 'product') {
      const productId = parseInt(item.id, 10);
      if (!Number.isNaN(productId)) {
        line.product_id = productId;
      }
    }

    return line;
  });
}
